import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'

import utils from '../utils'
const { $, FE } = utils
const APP_VER = FE.APP.getAppVer()
const IS_ALLOW = FE.APP.compareIntVer(APP_VER,'9.13.4')>0

@inject('cityInfo')
@observer
export default class CitySel extends Component {
  render(){
    let { cityInfo } = this.props,{ isShow } = cityInfo,
    modalClass = isShow?'ath-tier-modal ath-tier-modal--hide ath-tier-modal--active':'ath-tier-modal ath-tier-modal--hide'

    return(
      <div className={modalClass}>
        <div className="ath-tier-modal__stair">
          <div className="ath-tier-modal__header">
            <p className="ath-tier-modal__title">选择省份</p>
            <a href="" className="ath-tier-modal__return" onClick={cityInfo.hide}>
              <i className="ath-icon ath-icon-arrowleft"></i>
            </a>
          </div>
          <div className="ath-tier-modal__stair-wrapper" id="JS-stairWrapper">
            <ul className="ath-tier-modal__list" id="JS-provinceList"></ul>
          </div>
        </div>
        <div className="ath-letter" id="JS-Slideletter"></div>
        <div className="ath-half-modal ath-half-modal--hide" id="JS-cityWrap">
          <div className="ath-half-modal__shadow" id="JS-cityShadow"></div>
          <div className="ath-half-modal__wrapper">
            <div className="ath-tier-modal__header">
              <p className="ath-tier-modal__title">选择城市</p>
              <a href="" className="ath-tier-modal__return" id="JS-cityWrap__return">
                <i className="ath-icon ath-icon-arrowleft"></i>
              </a>
            </div>
            <div className="ath-tier-modal__tap ath-tier-modal__tap--gray" id="JS-selPro">安徽</div>
            <ul className="ath-tier-modal__list city-list" id="JS-cityList"></ul>
          </div>
        </div>
      </div>
    )
  }
  componentDidMount(){
    let { cityInfo } = this.props

    if(FE.APP.IS_APP && IS_ALLOW){
      window.AHAPP.invokeNative("getSyncCity",{
        success: function(result) {
          cityInfo.changeCity(result.result)
        },
        fail: function(result) {
        }
      });
    }

    const province = window.province,city = window.city

    let selCityRes = {}
    //城市选择
    let $cityWrap = $("#JS-cityWrap"),
    $provinceList = $("#JS-provinceList"),
    $cityList = $("#JS-cityList")
    
    $provinceList.on("touch click",".ath-tier-modal__item",function(){
      renderCity($(this).data("ProvinceId"))
      $("#JS-selPro").html($(this).html())

      selCityRes.provinceId = $(this).data("ProvinceId")
      selCityRes.provinceName = $(this).html()

      $cityWrap.addClass("ath-half-modal--active")
    })
    $cityList.on("touch click",".ath-tier-modal__item",function(){
      $cityWrap.removeClass("ath-half-modal--active")

      selCityRes.cityId = $(this).data("cityid")
      selCityRes.cityName = $(this).html()

      if(selCityRes.cityId !== cityInfo.info.cityId) {
        cityInfo.changeCity(selCityRes)
        setCookieExpireDayDomain("mallCityId",selCityRes.cityId,7,"autohome.com.cn")
        if(FE.APP.IS_APP && IS_ALLOW){
          // H5设置Native当前选择城市
          window.AHAPP.invokeNative('updatecity',{
            cityid: selCityRes.cityId,
            success: function (result) {
              // console.log((result.message));
            },
            fail: function(result) {
              // console.log((result.message));
            }
          });
        }
      }
      cityInfo.hide()
    })

    $("#JS-cityModal__return").on("touch click",function(){
      cityInfo.hide()
    })
    $("#JS-cityWrap__return").on("touch click",function(){
      $cityWrap.removeClass("ath-half-modal--active")
    })
    $("#JS-cityShadow").on("touch click",function(){
      $cityWrap.removeClass("ath-half-modal--active")
    })

    function setCookieExpireDayDomain(name,value,day,domain){
      var exp = new Date();
      exp.setTime(exp.getTime() + day*24*60*60*1000);
      document.cookie = name + "="+ encodeURIComponent(value) + ";expires=" + exp.toGMTString() + ";path=/" + ";domain=" + domain;
    }
    function initProvince(){
      province[0].map(function(ele,index){
        var provinceItem = $('<li class="ath-tier-modal__item">'+ele.ProvinceName+'</li>').data({
          ProvinceId: ele.ProvinceId
        })
        if(!hasTap(ele.FirstCode)){
          var tapItem = $('<li class="ath-tier-modal__tap">'+ele.FirstCode+'</li>')
          $provinceList.append(tapItem)
        }
        $provinceList.append(provinceItem)
      })
    }
    function hasTap(fc){
      var res = false
      $(".ath-tier-modal__tap",$provinceList).map(function(index,tap){
        if($(tap).html() === fc) res = true
      })
      return res
    }
    initProvince()
    function renderCity(pId){
      $cityList.empty()
      city[pId].map(function(city,index){
        var cityItem = $('<li class="ath-tier-modal__item">'+city.CityName+'</li>').data({
          cityid: city.CityId
        })
        $cityList.append(cityItem)
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/CitySel.js